/**
 * Homepage/UI string catalog for the top-level pages. Generated by
 * `scripts/translate_homepage_strings.py` (Claude Sonnet 4.5) and safe
 * to regenerate — you'll only lose manual tweaks to translated values.
 *
 * The catalog is a flat two-level object: { <lang>: { <key>: 'value' } }.
 * The exported `hp(lang, key)` helper falls back to English when a
 * translation is missing so partial coverage never breaks rendering.
 */
import strings from './homepageStrings.json';

const EN = strings.en || {};

export const hp = (lang, key) => {
  const bundle = strings[lang] || EN;
  return bundle[key] || EN[key] || key;
};

export default strings;
